<template>
  <p class="view-toggle">
    <span class="view-mode-title font-weight-bold">Visualizza: </span>
    <template v-for="option in options">
      <button class="btn btn-link px-1" :class="{ 'font-weight-bold' : viewMode === option.name }" @click.prevent="$emit('update:viewMode', option.name)" :key="option.name">
        {{ option.label }}
      </button>
    </template>
  </p>
</template>

<script>

export default {
  name: 'forecast-list-switcher',
  props: {
    viewMode: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [
        { name: 'forecast', label: 'Previsionale' },
        { name: 'list', label: 'Elenco' },
      ],
    },
  },
};

</script>

<style lang="scss">

.view-toggle {
  .view-mode-title {
    line-height: 1.5rem;
    vertical-align: middle;
  }
}

</style>
